module.exports = __webpack_public_path__ + "img/tea_du.d9bc958d.jpeg";